import React from 'react';
import Components from './components/Components';
import ScrolToTop from './components/Elements/ScrolToTop';
import Loader from "./components/Elements/Loader";
import WhatsAppButton from './components/Elements/WhatsAppButton';

const App = () => {
  
  return (
    <div className="App">
      <WhatsAppButton />
      <Components />  
      <ScrolToTop/>
    </div>
  );
}

export default App;